import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const PublicLayout = () => {
  return (
    <>
      <Navbar />

      {/* Main landmark for accessibility */}
      <main id="main-content" role="main">
        <Outlet />
      </main>

      <Footer />
    </>
  );
};

export default PublicLayout;
